import { map, mergeMap, tap, filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of as observableOf, Observable } from 'rxjs';

import { TrackingService } from '../services/tracking.service';
import { TrackingActionTypes, Enqueue } from '../actions/tracking';
import { Event } from '../models/event';
import eventsMap from '../events';
import { MANUAL_SEARCH, AUTOCOMPLETE_SEARCH } from '@app/store';
import { SessionCookieService } from '@app/core/cookies';

@Injectable()
export class TrackingEffects {
  @Effect()
  queue$: Observable<Action> = this.actions$.pipe(
    ofType<Action>(...Object.keys(eventsMap)),
    filter(action => {
      const userId = this.sessionCookieService.getUserId();
      return !([MANUAL_SEARCH, AUTOCOMPLETE_SEARCH].includes(action.type) && !userId);
    }),
    mergeMap(action => {
      return observableOf(new Enqueue(this.getEvents(action)));
    })
  );

  @Effect({ dispatch: false })
  send$ = this.actions$.pipe(
    ofType<Enqueue>(TrackingActionTypes.Enqueue),
    map(action => action.payload),
    tap(events => this.tracker.send(...events))
  );

  constructor(
    private actions$: Actions,
    private tracker: TrackingService,
    private sessionCookieService: SessionCookieService
  ) {}

  private getEvents(action: Action): Event[] {
    return eventsMap[action.type](action);
  }
}
